import React from 'react';
import { courses } from '../mock/data';
import { useReveal } from '../hooks/useReveal';
import CourseCard from './courses/CourseCard';

export default function Courses() {
  const { ref, inView } = useReveal();
  return (
    <section id="courses" className="py-20 md:py-28 bg-[var(--pca-blue-tint)]">
      <div className="container-x">
        <div ref={ref} className={`reveal ${inView ? 'in-view' : ''} text-center max-w-2xl mx-auto`}>
          <span className="section-eyebrow">OUR PROGRAMS</span>
          <h2 className="section-title mt-4 text-[34px] md:text-[44px] leading-tight">Courses that shape careers</h2>
          <p className="mt-4 text-slate-600">Choose from our PCI approved programs designed for both undergraduate and diploma level students.</p>
        </div>

        <div className="mt-12 grid gap-6 lg:grid-cols-2">
          {courses.map((c, i) => <CourseCard key={c.code} course={c} index={i} />)}
        </div>
      </div>
    </section>
  );
}
